<template>
  <div class="table-wrapper px-3 pb-3 pt-2">
    <div class="table-scroll" :style="{height, 'overflow': autoScroll && 'auto'}">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    height: {
      type: String,
      default: '220px'
    },
    autoScroll:{
      type: Boolean,
      default: false
    }
  }
}
</script>
<style>
.table-wrapper {
  overflow-x: auto;
  width: 100%;
  th {
    font-size: 12px !important;
    font-weight: 700 !important;
    line-height: 16px !important;
    color: #8AA1AC !important;
  }
  th, td {
    padding-right: 4px !important;
    padding-left: 4px !important;
  }
  tbody tr:nth-child(2n - 1){
    background-color: #F5F5F5 ;
  }
  thead {
    position: sticky;
    top: 0;
    z-index: 4;
    background-color: white;
  }
  table.v-table tbody td {
    font-size: 12px ;
    color: #232323;
  }
  .v-table__overflow {
    overflow: visible;
  }
}
.table-scroll {
  overflow: scroll;
  scrollbar-color: #B0BEC5 #F5F5F5;
}
</style>
